import styled from 'styled-components'

export const NoScrollContainer = styled.div``
